var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1925 3.02719C15.2803 2.04234 14.0062 1.5 12.6 1.5C11.1862 1.5 9.90797 2.03906 9 3.01781C8.08219 4.00734 7.635 5.35219 7.74 6.80437C7.94812 9.66937 10.1283 12 12.6 12C15.0717 12 17.2481 9.66984 17.4595 6.80531C17.5659 5.36625 17.1159 4.02422 16.1925 3.02719ZM20.85 22.5H4.35C4.13403 22.5028 3.92015 22.4574 3.72392 22.3672C3.52769 22.2769 3.35405 22.1441 3.21562 21.9783C2.91094 21.6141 2.78812 21.1167 2.87906 20.6137C3.27469 18.4191 4.50937 16.5755 6.45 15.2812C8.17406 14.1323 10.358 13.5 12.6 13.5C14.842 13.5 17.0259 14.1328 18.75 15.2812C20.6906 16.575 21.9253 18.4186 22.3209 20.6133C22.4119 21.1162 22.2891 21.6136 21.9844 21.9778C21.846 22.1437 21.6724 22.2766 21.4761 22.367C21.2799 22.4573 21.066 22.5028 20.85 22.5Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon_profile.178e8a5c19b95f901999cd6dceed5b9e.svg";
export { ForwardRef as ReactComponent };